import { colors } from 'constants/colors';
import { useDispatch, useSelector } from 'react-redux';
import { selectLayout, setAddingProjectBottom } from 'store/layoutSlice';
import { selectWorkspaceId } from 'store/userSlice';
import { selectWorkspaceData } from 'store/workspaceSlice';
import Button from '../../layout/atoms/Button';
import { AppDispatch } from '../../store';

const getRandomNonTakenColor = (takenColors: string[]): string => {
    const availableColors = colors.filter(
        (color) => !takenColors.includes(color)
    );

    if (availableColors.length === 0) {
        const randomRed = Math.floor(Math.random() * 256);
        const randomGreen = Math.floor(Math.random() * 256);
        const randomBlue = Math.floor(Math.random() * 256);
        return `rgb(${randomRed}, ${randomGreen}, ${randomBlue})`;
    }

    const randomIndex = Math.floor(Math.random() * availableColors.length);
    return availableColors[randomIndex];
};

export const AddProject = () => {
    const workspaceId = useSelector(selectWorkspaceId);
    const workspaceData = useSelector(selectWorkspaceData);
    const layoutState = useSelector(selectLayout);
    const dispatch: AppDispatch = useDispatch();

    const onAddNewProject = () => {
        dispatch(setAddingProjectBottom(true));
    };

    const addingDisabled = workspaceData.access.projectsLimit !== null && workspaceData.access.projectsLimit <= workspaceData.projects.length;
    
    // Hide the button only when adding a project at the bottom
    if (layoutState.addingProjectBottom) {
        return null;
    }
    
    return (
        <div>
            <Button theme="plain" onClick={onAddNewProject} disabled={addingDisabled}>
                + New Project
            </Button>
        </div>
    );
};
